import { masterApi, BACKEND_URL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { modal } from "@/lib/modal";

/** Trigger Excel file download using the master token. */
export async function downloadExcel(url, filename) {
  try {
    const token = localStorage.getItem("master_token");
    const res = await fetch(`${BACKEND_URL}/api${url}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error("Falha no download");
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
    modal.success("Download iniciado");
  } catch (e) {
    modal.error("Erro ao baixar: " + (e.message || "desconhecido"));
  }
}

export function ExcelBtn({ url, filename, label = "Excel", testid }) {
  return (
    <Button variant="outline" data-testid={testid || "excel-btn"}
            onClick={() => downloadExcel(url, filename)}
            className="h-11 px-4 rounded-[12px] border border-[var(--line)] bg-white text-[color:var(--ink)] hover:bg-neutral-50 shadow-sm font-display uppercase text-xs">
      <Download size={14} className="mr-1"/> {label}
    </Button>
  );
}
